export const READ_DYNAMICPAGE_REQUEST = 'READ_DYNAMICPAGE_REQUEST';
export const READ_DYNAMICPAGE_SUCCESS = 'READ_DYNAMICPAGE_SUCCESS';
export const READ_DYNAMICPAGE_FAILURE = 'READ_DYNAMICPAGE_FAILURE';
export const CLEAR_DYNAMICPAGE_REQUEST = 'CLEAR_DYNAMICPAGE_REQUEST';
